// One axios client setup for the whole app (main API and the Domains module).
// Both used to carry their own copy of the token / 401 / error handling and
// had already drifted apart.
import axios from "axios";

import safeStorage from "./safeStorage";
import { translateErrorDetail } from "./serverMessage";

export const TOKEN_KEY = "xpnsr_seo_token";

const AUTH_ENDPOINTS = ["/auth/login", "/auth/register", "/auth/accept-invite", "/auth/change-password"];
// Public flows (invite acceptance, forced password change after an admin
// reset) must NOT be hijacked into a redirect - the user is typing there.
const PUBLIC_FLOWS = ["/accept-invite", "/change-password"];

export function backendBase(suffix) {
  const raw = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
  return raw ? raw + suffix : suffix;
}

export function attachToken(config) {
  const token = safeStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
}

export function handleResponseError(error, win = typeof window !== "undefined" ? window : undefined) {
  translateErrorDetail(error);
  const status = error?.response?.status;
  const url = error?.config?.url || "";
  const isAuthEndpoint = AUTH_ENDPOINTS.some((p) => url.includes(p));
  if (status === 401 && !isAuthEndpoint) {
    safeStorage.removeItem(TOKEN_KEY);
    const path = win ? win.location.pathname : "";
    if (win && !PUBLIC_FLOWS.includes(path)) {
      if (path !== "/") win.location.href = "/";
      else win.location.reload();
    }
  }
  return Promise.reject(error);
}

export function createApiClient(suffix) {
  const api = axios.create({
    baseURL: backendBase(suffix),
    headers: { "Content-Type": "application/json" },
  });
  api.interceptors.request.use(attachToken);
  api.interceptors.response.use((response) => response, (error) => handleResponseError(error));
  return api;
}
